import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {
  AiChatAttachmentUploadResult,
  AiChatAttachmentsAcceptedTypes,
} from '../models/ai-chat-attachment.model';

const ACCEPTED_TYPES_URL = '/core/ai-chat/attachments/accepted-types';
const UPLOAD_URL = '/core/ai-chat/attachments';

export type AiChatAttachmentUploadEvent =
  | {kind: 'progress'; progress: number}
  | {kind: 'result'; result: AiChatAttachmentUploadResult};

@Injectable({
  providedIn: 'root',
})
export class AiChatAttachmentsService {
  constructor(private readonly http: HttpClient) {}

  /** Список допустимых типов и лимитов загрузки. */
  getAcceptedTypes(): Observable<AiChatAttachmentsAcceptedTypes> {
    return this.http.get<AiChatAttachmentsAcceptedTypes>(ACCEPTED_TYPES_URL);
  }

  /** Загрузка файла во временное хранилище Chat V3 */
  upload(file: File): Observable<AiChatAttachmentUploadResult> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<AiChatAttachmentUploadResult>(UPLOAD_URL, formData);
  }

  /** Загрузка файла с прогрессом (0..100) и финальным результатом. */
  uploadWithProgress(file: File): Observable<AiChatAttachmentUploadEvent> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http
      .post<AiChatAttachmentUploadResult>(UPLOAD_URL, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event): AiChatAttachmentUploadEvent | null => {
          if (event.type === HttpEventType.UploadProgress) {
            const total = event.total ?? file.size;
            const progress = total > 0 ? Math.min(100, Math.round((event.loaded / total) * 100)) : 0;
            return {kind: 'progress', progress};
          }

          if (event.type === HttpEventType.Response && event.body) {
            return {kind: 'result', result: event.body};
          }

          return null;
        }),
        filter((event): event is AiChatAttachmentUploadEvent => event !== null),
      );
  }
}
